import { useRouteMatch } from 'react-router-dom';
import { PUBLIC_ROUTES } from './routes';

export const useIsPublicPage = () => !!useRouteMatch(PUBLIC_ROUTES);
